// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1473":"css/app.6676","5342":"css/admin-app.6676"}[chunkId] + ".css";
};